// src/pages/Products.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Products() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-14">
      
      {/* Page Header */}
      <div className="text-center max-w-3xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">
          Products
        </h1>
        <p className="mt-3 text-sm sm:text-base text-neutral-400">
          Choose your protection level and finish. Every film is professional grade wrap material.
        </p>
      </div>

      {/* Two Product Tiles */}
      <div className="mt-10 grid gap-6 sm:grid-cols-2 max-w-3xl mx-auto">
        
        {/* Clear PPF */}
        <Link
          to="/clear-ppf"
          className="rounded-2xl border border-neutral-800 bg-neutral-950/80 overflow-hidden hover:border-neutral-500 transition group"
        >
          <div className="relative aspect-[4/3] overflow-hidden">
            <img
              src="/assets/products/clear-ppf.jpg"
              alt="Clear PPF"
              className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80" />
            <div className="absolute bottom-3 left-4 right-4">
              <div className="text-white text-lg font-semibold">Clear PPF</div>
              <div className="text-[11px] uppercase tracking-wide text-neutral-400">
                Ultra gloss & stealth matte options
              </div>
            </div>
          </div>
        </Link>

        {/* Colored PPF */}
        <Link
          to="/colors"
          className="rounded-2xl border border-neutral-800 bg-neutral-950/80 overflow-hidden hover:border-neutral-500 transition group"
        >
          <div className="relative aspect-[4/3] overflow-hidden">
            <img
              src="/assets/products/colored-ppf.jpg"
              alt="Colored PPF"
              className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80" />
            <div className="absolute bottom-3 left-4 right-4">
              <div className="text-white text-lg font-semibold">Colored PPF</div>
              <div className="text-[11px] uppercase tracking-wide text-neutral-400">
                Massive range of finishes + colors
              </div>
            </div>
          </div>
        </Link>

      </div>
    </section>
  );
}
